import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/resident",
  name: "/resident",
  redirect: {
    name: "resident",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/resident/list",
      name: "residentList",
      meta: {
        ...meta,
        title: "人口管理",
        cache: true,
      },
      component: () => import("@/pages/resident/ResidentList.vue"),
    },
    {
      path: "/resident/add",
      name: "residentAdd",
      meta: {
        ...meta,
        title: "人口新增",
      },
      component: () => import("@/pages/resident/ResidentAdd.vue"),
    },
  ],
};
